var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { CommonActions, CommonSelectors, JourneysSelectors, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject, CTA_TYPES, ExitIntent as ExitIntentContainer, } from 'conversional-components';
import { ENGINES, getItem, setItem } from 'conversional-persistent-storage';
import { exitIntentConfig } from 'conversional-environment';
import { useListener, useRpcListener } from '../utils/listener';
import { CLOSED, OPEN } from './General.styles';
import * as CALL_TO_ACTIONS from '../constants/callToActions';
var TIME_TO_LIVE = 86400000; // 1000ms * 60s * 24hours
var STORAGE_ENGINE = ENGINES.LOCAL_STORAGE;
var PARENT_BODY = {
    height: '100%',
    margin: 0,
    overflow: 'hidden',
};
var CTA_TYPE = CTA_TYPES.EXIT_INTENT;
/**
 * ExitIntent View
 * appears once
 * permanently remebers its previous show state

 //TODO: add preloading of images and videos - see start.js
 **/
var ExitIntent = function (_a) {
    var onApplyStyles = _a.onApplyStyles, Children = _a.Children, exitIntentProps = __rest(_a, ["onApplyStyles", "Children"]);
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var dispatch = useAppDispatch();
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var activeCTA = useAppSelector(CommonSelectors.selectActiveCTA);
    var isOtherCTAActive = function () { return activeCTA && activeCTA !== CTA_TYPE; };
    var shouldHideExitIntent = function () {
        return getItem(exitIntentConfig.HIDE_FLAG, {}, STORAGE_ENGINE) === 'true';
    };
    var destroy = function () {
        sendToHost.resetBodyStyles();
        sendToHost.triggerPageTitle(false);
        sendToHost.destroy();
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: null,
        }));
        setItem(exitIntentConfig.HIDE_FLAG, 'true', { ttl: TIME_TO_LIVE }, STORAGE_ENGINE);
    };
    React.useEffect(function () {
        sendToHost.styleIframe(CLOSED, true);
        if (shouldHideExitIntent()) {
            destroy();
        }
    }, []);
    var onTrigger = function () {
        if (shouldHideExitIntent() || window.exitIntentDisabled || isOtherCTAActive()) {
            return;
        }
        dispatch(CommonActions.broadcastSharedStoreChange({
            activeCTA: CTA_TYPE,
        }));
        setItem(exitIntentConfig.HIDE_FLAG, 'true', { ttl: TIME_TO_LIVE }, STORAGE_ENGINE);
        setOpen(true);
        sendToHost.styleParentBody(PARENT_BODY);
        sendToHost.styleIframe(OPEN, true);
        sendToHost.triggerPageTitle(true);
        onApplyStyles();
    };
    var onClick = function () {
        dispatch(CommonActions.logCta(CALL_TO_ACTIONS.EXIT_INTENT));
        sendToHost.publish(MESSAGETYPES.JOURNEY_SHOW); // Can be made more flexible by adding journeyId as parameter
    };
    useListener(MESSAGETYPES.JOURNEY_SHOW_ENTRY, destroy);
    useListener(MESSAGETYPES.JOURNEY_SHOW_RESULT, destroy);
    useRpcListener(MESSAGETYPES.RPC_OPEN_EXIT_INTENT, onTrigger);
    useRpcListener(MESSAGETYPES.RPC_DISABLE_EXIT_INTENT, destroy);
    var shouldShow = function () {
        return (getItem(exitIntentConfig.HIDE_FLAG, {}, STORAGE_ENGINE) !== 'true' &&
            !window.exitIntentDisabled);
    };
    return (_jsx(ExitIntentContainer, __assign({ open: open, onClose: destroy, onTrigger: onTrigger, onClick: onClick, shouldShow: shouldShow }, exitIntentProps, { children: Children && createComponentsFromObject(Children) })));
};
export default ExitIntent;
